import api from '~services/axios';
import { taskHelper } from 'http-scheduler/dist/bundle-umd';

const { autoCancel } = taskHelper;

export default {
  // 合同列表
  apiGetCompactList: params =>
    autoCancel(
      api.post('/api/crmcontract/query', params),
      () => 'compact:apiGetCompactList',
    ),

  apiGetCompactCount: params => api.post('/api/crmcontract/count', params),

  apiGetCategoryData: params =>
    api.get('/api/common/query/category', { params }),

  apiGetBusiSelectData: params =>
    api.get('/api/crmcontract/query/business', { params }),

  apiGetCustomSelectData: params =>
    api.get('/api/crmcontract/query/customer', { params }),

  apiSaveAddCompact: params => api.post('/api/crmcontract/add', params),

  apiDeleteCompact: params => api.post('/api/crmcontract/delete', params),

  apiGetCompactDetail: params => api.get('/api/crmcontract/detail', { params }),

  apiUpdateCompact: params => api.post('/api/crmcontract/update', params),

  apiGetReturndRecord: params =>
    api.get('/api/crmcontract/query/receivable', { params }),

  apiDeleteReturnRecord: params =>
    api.post('/api/crmcontract/delete/receivable', params),

  apiSaveAddReturnRecord: params =>
    api.post('/api/crmcontract/add/receivable', params),
  apiGetReturndRecordDetail: params =>
    api.get('/api/receivableManagement/detail', { params }),

  apiSaveUpdateReturnRecord: params =>
    api.post('/api/crmcontract/update/receivable', params),

  apiGetCompactFileList: params =>
    api.get('/api/crmcontract/query/file', { params }),

  apiUploadCompactFile: (params, config) =>
    api.post('/api/crmcontract/upload/file', params, config),

  apiDeleteCompactFile: params =>
    api.post('/api/crmcontract/delete/file', params),

  apiCompactExport: (params, config) =>
    api.post('/api/crmcontract/download', params, config),

  apiGetCompactCostList: params =>
    api.get('/api/crmcontract/query/cost', { params }),

  apiGetCostType: params => api.get('/api/common/query/category', { params }),

  apiSaveAddCompactCost: params =>
    api.post('/api/crmcontract/add/cost', params),

  apiSaveUpdateCompactCost: params =>
    api.post('/api/crmcontract/update/cost', params),

  apiDeleteCompactCost: params =>
    api.post('/api/crmcontract/delete/cost', params),
  // 获取合同团队
  apiGetCompactTeams: params =>
    api.get('/api/crmcontract/queryteam', { params }),
  // 获取业务员下拉框数据
  apiGetCompactSalesman: params =>
    api.get('/api/crmcontract/query/salesman', { params }),
  // 获取回款列表数据
  apiGetMoneyBackData: params =>
    api.get('/api/crmcontract/query/receivable/page', { params }),
  // 获取成本列表数据
  apiGetCostDataList: params =>
    api.get('/api/crmcontract/query/cost/page', { params }),
  // 合同详细费用列表
  apiGetPayDataList: params =>
    api.get('/api/crmcontract/query/fee', { params }),
  apiGetPayType: params => api.get('/api/common/query/category', { params }),
  // 新增费用
  apiSaveAddCompactFee: params =>
    api.post('/api/crmcontract/insert/fee', params),
  // 编辑费用
  apiUpdateCompactFee: params =>
    api.post('/api/crmcontract/update/fee', params),
  // 删除费用
  apiDeleteCompactFee: params =>
    api.post('/api/crmcontract/delete/fee', params),
  // 回款导入
  apiUploadBackData: (params, config) =>
    api.post('/api/receivableManagement/importReceivable', params, config),
  // 成本导入
  apiUploadCostData: (params, config) =>
    api.post('/api/crmcontract/upload/cost', params, config),
  // 合同回款-删除
  apiMoneyDelete: params =>
    api.post('/api/crmcontract/delete/receivable', params),
  // 合同回款-批量删除
  apiMoneyDeletelist: params =>
    api.post('/api/crmcontract/delete/receivablebatch', params),
  // 合同成本- 删除
  apiCostDeletelist: params =>
    api.post('/api/crmcontract/delete/costbatch', params),
  // 合同成本 - 批量删除
  apiCostDelete: params => api.post('/api/crmcontract/delete/cost', params),
  // 支出合同列表
  apiContractSupport: params => api.get('/api/contractSupport/query', params),
  // 支出合同列表获取业务员接口
  apiSpendQueryTeam: params => api.get('/api/contractSupport/query/teamuser'),
  // 新增支出合同
  apiAddSupport: params => api.post('/api/contractSupport/add', params),
  // 修改支出合同
  apiUpdateSupport: params => api.post('/api/contractSupport/update', params),
  // 删除支出合同
  apiDeleteSupport: params => api.post('/api/contractSupport/delete', params),
  // 导出支出合同
  apiExportSupport: params => api.post('/api/contractSupport/export', params),
  // 获取支出合同详情
  apiDetailSupport: params => api.get('/api/contractSupport/detail', params),
  // 新增回款 - 获取所有我方银行信息
  apiGetMyBankInfo: params =>
    api.get('/api/receivableManagement/queryMyAccountInfo', params),
  // 新增回款 - 获取所有预算单元
  apiGetBudgetUnit: params =>
    api.get('/api/receivableManagement/queryMinimumBudgetUnit', params),
  // 新增回款 - 获取当前登录人的业务结算部门
  apiGetUserDept: params =>
    api.get(
      '/api/receivableManagement/queryCurrentUserBusinessAccountInfo',
      params,
    ),
  // 新增回款 - 获取所有业务结算部门(级联)
  apiGetAllDept: params =>
    api.get('/api/receivableManagement/querybusinessAccountDept', params),
  // 新增回款 - 获取所有的发票记录
  apiGetInvoice: params =>
    api.get('/api/receivableManagement/queryInvoiceInfo', { params }),
  // 新增回款 - 附件上传
  apiUploadFile: params =>
    api.post('/api/receivableManagement/fileUpload', params, {
      'Content-Type': 'multipart/form-data',
    }),
  // 新增回款 - 新增回款记录
  apiAddPayback: params => api.post('/api/receivableManagement/add', params),
  // 新增回款 - 修改回款记录
  apiEditPayback: params =>
    api.post('/api/receivableManagement/update', params),
  // 回款列表 - 列表查询
  apiQueryList: params =>
    api.post('/api/receivableManagement/queryList', params),
  // 回款列表 - 删除回款记录
  apiDeletePayback: params =>
    api.post('/api/receivableManagement/delete', params),
  // 回款列表 - 查看详情
  apiGetPaybackDetail: params =>
    api.get('/api/receivableManagement/detail', { params }),
  // 回款列表 - 搜索 - 获取所有客户
  apiGetCustomerList: params =>
    api.get('/api/receivableManagement/queryCustomerList', { params }),
  // 回款列表 - 搜索 - 获取所有业务员
  apiGetSalesManList: params =>
    api.get('/api/receivableManagement/querySalesmanList', { params }),
  // 查看发票详情
  apiGetBillsRecordDetail: params =>
    api.get('/api/crmcontract/detail/receivable', { params }),
  // 添加发票
  apiSaveAddBillsRecord: params =>
    api.post('/api/crmcontract/add/receivable', params),
  // 保存编辑
  apiSaveUpdateBillsRecord: params =>
    api.post('/api/crmcontract/update/receivable', params),
  // 删除发票
  apiDeleteBillsRecord: params =>
    api.post('/api/crmcontract/delete/receivable', params),
  // 发票列表查询
  apiGetBillsRecord: params =>
    api.get('/api/crmcontract/query/receivable', { params }),
  queryProductLineList: params =>
    api.get('/api/crmcontract/queryProductLineList', { params }),
  receivableCount: params =>
    api.post('/api/receivableManagement/receivableCount', params),
  updateSalesman: params =>
    api.post('/api/receivableManagement/updateSalesman', params),
  // 回款计划列表查询
  apiReceivablePlanList: params =>
    api.get('/api/receivablePlan/queryList', { params }),
  // 回款计划修改
  apiUpdateReceivablePlan: params =>
    api.post('/api/receivablePlan/update', params),
  // 获取回款期数列表
  apiQueryPlanList: params =>
    api.get('/api/receivablePlan/queryPlanList', { params }),
};
